import styled from "@emotion/styled";
import { ToggleButton } from "react-aria-components";

export const StyledToggleButtonGroupItem = styled(ToggleButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing["1"]};
  cursor: pointer;
  border: none;
  outline: none;
  font-size: ${({ theme }) => theme.fontSizes["text-s"]};
  line-height: ${({ theme }) => theme.lineHeights["text-s"]};
  transition: all 0.15s ease;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  padding: ${({ theme }) => theme.spacing["2"]};

  font-weight: ${({ theme }) => theme.fontWeights.regular};
  background: ${({ theme }) => theme.colors.surface.menu};
  color: ${({ theme }) => theme.colors.text.tertiary};

  &[data-selected] {
    font-weight: ${({ theme }) => theme.fontWeights.smedium};
    background: ${({ theme }) => theme.colors.background.button.chip.default};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  z-index: 1;

  &[data-disabled] {
    z-index: 0;
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[data-focus-visible] {
    z-index: 2;
    outline: 2px solid ${({ theme }) => theme.colors.border.emphasis};
    outline-offset: 2px;
  }
`;
